export const LEFT_NAV_BACKGROUND_COLOR = '#ffffff';
